import { PAGE_SHOW_LOADING_SPINNER } from './constants';

export function showPageLoadingSpinner(showLoadingSpinnerPage) {
  return {
    type: PAGE_SHOW_LOADING_SPINNER,
    payload: { showLoadingSpinnerPage },
  };
}
